import { render, staticRenderFns } from "./SmartAmbientePage.vue?vue&type=template&id=652de50b&scoped=true&"
import script from "./SmartAmbientePage.vue?vue&type=script&lang=js&"
export * from "./SmartAmbientePage.vue?vue&type=script&lang=js&"
import style0 from "./SmartAmbientePage.vue?vue&type=style&index=0&id=652de50b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652de50b",
  null
  
)

export default component.exports